<template>
  <div id="agentmanage">
    <el-row :gutter="3">
      <el-col :span="24">
        <el-col :span="8">
          <span class="titels ">{{this.$store.getters.WordsConfig.Index.dayIncome}}：</span>
        </el-col>
        <el-col :span="4">
          <span class="titels2">{{this.subpromoterdata.todayUserProfit}}</span>
        </el-col>
        <el-col :span="8">
          <span class="titels">{{this.$store.getters.WordsConfig.Index.monthIncome}}：</span>
        </el-col>
        <el-col :span="4">
          <span class="titels2">{{this.subpromoterdata.monthUserProfit}}</span>
        </el-col>
      </el-col>
      <el-col :span="24">
        <el-col :span="8">
          <span class="titels">{{this.$store.getters.WordsConfig.Index.returnRate}}：</span>
        </el-col>
        <el-col :span="4">
          <span class="titels2">{{this.subpromoterdata.rebates}}</span>
        </el-col>
        <el-col :span="8">
          <span class="titels">{{this.$store.getters.WordsConfig.Index.canWithdraw}}：</span>
        </el-col>
        <el-col :span="4">
          <span class="titels2">{{this.subpromoterdata.cashable}}</span>
        </el-col>
      </el-col>
      <el-col :span="24">
        <el-col :span="8">
          <span class="titels">{{this.$store.getters.WordsConfig.Index.dayNewPlayer}}：</span>
        </el-col>
        <el-col :span="4">
          <span class="titels2">{{this.subpromoterdata.todayAddUser}}</span>
        </el-col>
        <el-col :span="8">
          <span class="titels">{{this.$store.getters.WordsConfig.Index.monthNewPlayer}}：</span>
        </el-col>
        <el-col :span="4">
          <span class="titels2">{{this.subpromoterdata.monthAddUser}}</span>
        </el-col>
      </el-col>
      <el-col :span="24">
        <el-col :span="8">
          <span class="titels">{{this.$store.getters.WordsConfig.Index.dayNewAgent}}：</span>
        </el-col>
        <el-col :span="4">
          <span class="titels2">{{this.subpromoterdata.todayAddPromoter}}</span>
        </el-col>
        <el-col :span="8">
          <span class="titels">{{this.$store.getters.WordsConfig.Index.monthNewAgent}}：</span>
        </el-col>
        <el-col :span="4">
          <span class="titels2">{{this.subpromoterdata.monthAddPromoter}}</span>
        </el-col>
      </el-col>
    </el-row>
    <div style="height:10px;"></div>
    <div style="position: absolute;top: 130px;left: 0;right: 0;bottom: 26px;">
      <el-table :data="table"
                height="100%"
                :empty-text="this.$store.getters.WordsConfig.TBEmptyText">
        <el-table-column fixed
                         prop="agent_id"
                         :label="this.$store.getters.WordsConfig.AgentManage.agent_id"
                         width="88"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="agent_name"
                         :label="this.$store.getters.WordsConfig.AgentManage.agent_name"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="agent_income"
                         :label="this.$store.getters.WordsConfig.AgentManage.agent_income"
                         width="150"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="agent_history"
                         :label="this.$store.getters.WordsConfig.AgentManage.agent_history"
                         width="150"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="agent_bindtime"
                         :label="this.$store.getters.WordsConfig.AgentManage.agent_bindtime"
                         width="160"
                         header-align="center"
                         align="center"></el-table-column>
      </el-table>
      <el-pagination small
                     class="pagination"
                     background
                     :total="this.$store.state.UserInfo.subPromoter"
                     :page-size="50"
                     layout="prev, pager, next"
                     @current-change="getNextPage"></el-pagination>
    </div>
  </div>
</template>

<script>
  import { G_SubP, SubPromoterDetail } from "../../api/api";
  export default {
    data() {
      return {
        table: [],
        table_height: 0,
        subpromoterdata: {
          cashable: 0,
          monthAddPromoter: 0,
          monthAddUser: 0,
          monthUserProfit: 0,
          rebates: 0,
          subPromoter: 0,
          todayAddPromoter: 0,
          todayAddUser: 0,
          todayUserProfit: 0,
          totalIncome: 0,
        }
      };
    },
    created() {
      this.getsubpromoterquery();
      //TODO 获取下线推广列表
      //this.getData(0);
    },
    methods: {
      getsubpromoterquery() {
        console.log("getsubpromoterquery()")
        SubPromoterDetail().then(result => {
          this.subpromoterdata = result.data[0];
          console.log(this.subpromoterdata)
        })
      },

      getData(page) {
        G_SubP(page)
          .then(result => {
            console.log("======================获取代理管理======================");
            let d = [];
            d = result;
            this.getSubP(d);
          })
          .catch(err => {
            console.log(err);
          });
      },
      getSubP(arr) {
        let data = [];
        for (let it of arr) {
          let agent = {
            agent_id: it.PromoterCode,
            agent_name: it.UserName,
            agent_income: it.MonthAward,
            agent_history: it.Award,
            agent_bindtime: it.BindDate
          };
          this.table.push(agent);
        }
      },
      getNextPage(currPage) {
        this.table = [];
        this.getData(currPage - 1);
      }
    }
  };
</script>

<style lang="scss" scoped>
  #agentmanage {
    height: 100%;
    overflow: hidden;
  }

  .pagination {
    position: absolute;
    bottom: -26px;
    width: 100%;
    background: white;
    text-align: center;
  }

  .el-row {
    padding: 0px 10px;
  }

  .titels {
    line-height: 30px;
    font-size: 14px;
    text-align: right;
    width: 100%;
    display: block;
  }
  .titels2 {
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    width: 100%;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cells/AgentManage.vue